import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Launch } from 'src/models/launch.model';
import { Instrument } from 'src/models/question.model';
import { QuestionnaireResponse } from 'src/models/questionnaire-response.model';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
    
  private dataIsQuestionSaving: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  currentIsQuestionSaving = this.dataIsQuestionSaving.asObservable();

  private dataQuestionnaireProgress: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  questionnaireProgress = this.dataQuestionnaireProgress.asObservable();

  SetSharedIsQuestionSaving(oIsQuestionSaving: boolean) {
    this.dataIsQuestionSaving.next(oIsQuestionSaving);
  }

  SetQuestionnaireProgress(oQuestionnaireProgress: number) {
    this.dataQuestionnaireProgress.next(oQuestionnaireProgress);
  }

  private _instrumentSubject = new BehaviorSubject<Instrument | undefined>(undefined)
  private _launchSubject = new BehaviorSubject<Launch | undefined>(undefined);
  private _questionnaireResponseSubject = new BehaviorSubject<QuestionnaireResponse | undefined>(undefined);
  private _previewModeSubject = new BehaviorSubject<boolean>(false);
  private _patientTermSubject = new BehaviorSubject<string>('');

  get instrument$(): Observable<Instrument | undefined> {
    return this._instrumentSubject.asObservable()
  }

  get instrument(): Instrument | undefined {
    return this._instrumentSubject.getValue()
  }

  set instrument(instrument: Instrument) {
    this._instrumentSubject.next(instrument)
  }

  get launch$(): Observable<Launch | undefined> {
    return this._launchSubject.asObservable()
  }

  get launch(): Launch | undefined {
    return this._launchSubject.getValue()
  }

  set launch(launch: Launch) {
    // assign default patient term 
    this.patientTerm = launch.patientTerm
    this._launchSubject.next(launch)
  }

  get questionnaireResponse$(): Observable<QuestionnaireResponse | undefined> {
    return this._questionnaireResponseSubject.asObservable()
  }

  get questionnaireResponse(): QuestionnaireResponse | undefined {
    return this._questionnaireResponseSubject.getValue()
  }

  set questionnaireResponse(questionnaire: QuestionnaireResponse) {
    this._questionnaireResponseSubject.next(questionnaire)
    // remove all sections that have no questions
    this._removeEmptySectionsFromInstrument()
  }

  get previewMode$(): Observable<boolean> {
    return this._previewModeSubject.asObservable()
  }

  get previewMode(): boolean {
    return this._previewModeSubject.getValue()
  }

  set previewMode(isPreview: boolean) {
      this._previewModeSubject.next(isPreview)
  }

  get patientTerm$(): Observable<string> {
    return this._patientTermSubject.asObservable()
  }

  get patientTerm(): string {
    return this._patientTermSubject.getValue()
  }

  set patientTerm(patientTerm: string) {
    this._patientTermSubject.next(patientTerm)
  }

  /**
   * Remove all sections that have no questions
   */
  private _removeEmptySectionsFromInstrument() {
    const instrument = this.instrument!
    const questionnaire = this.questionnaireResponse!

    const sections = instrument.section
    for(let section of sections!) {
      const questionsInSection = questionnaire.questions.filter(q => q.surveySection === section.sectionName)
      if(questionsInSection.length === 0) {
        instrument.section = instrument?.section.filter(s => s.sectionName !== section.sectionName)
      }
    }
  }


}